var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _g, _path12, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCompliant(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 72,
    height: 72,
    viewBox: "0 0 72 72",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.5469 51.9375H20.0625V55.4531H16.5469V51.9375Z",
    fill: "#161614"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16.5469 44.9062H20.0625V48.4219H16.5469V44.9062Z",
    fill: "#161614"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M23.5781 30.8438H43.1484V34.3594H23.5781V30.8438Z",
    fill: "#161614"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M23.5781 37.875H41.1562V41.3906H23.5781V37.875Z",
    fill: "#161614"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M23.5781 44.9062H37.1758V48.4219H23.5781V44.9062Z",
    fill: "#161614"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M23.5781 51.9375H37.1758V55.4531H23.5781V51.9375Z",
    fill: "#161614"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M16.5469 37.875H20.0625V41.3906H16.5469V37.875Z",
    fill: "#161614"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M16.5469 30.8438H20.0625V34.3594H16.5469V30.8438Z",
    fill: "#161614"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M23.5781 23.8125H43.1484V27.3281H23.5781V23.8125Z",
    fill: "#161614"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M16.5469 23.8125H20.0625V27.3281H16.5469V23.8125Z",
    fill: "#161614"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M51.9375 34.4576V9.51562H39.6328V6H18.3047V9.51562H6V66H50.1797C58.903 66 66 58.903 66 50.1797C66 42.0505 59.8366 35.3348 51.9375 34.4576ZM21.8203 9.51562H36.1172V13.0312H21.8203V9.51562ZM9.51562 62.4844V13.0312H18.3047V16.5469H39.6328V13.0312H48.4219V34.4576C45.3471 34.7991 42.5358 36.0251 40.2482 37.875H40.823V41.3906H37.032C36.3045 42.4754 35.708 43.6549 35.2643 44.9062H36.1172V48.4219H34.4576C34.3935 48.9993 34.3594 49.5855 34.3594 50.1797C34.3594 50.7738 34.3935 51.3601 34.4576 51.9375H36.1172V55.4531H35.2643C36.251 58.2357 37.9952 60.6623 40.2483 62.4844H9.51562ZM50.1797 62.4844C43.3949 62.4844 37.875 56.9645 37.875 50.1797C37.875 43.3949 43.3949 37.875 50.1797 37.875C56.9645 37.875 62.4844 43.3949 62.4844 50.1797C62.4844 56.9645 56.9645 62.4844 50.1797 62.4844Z",
    fill: "#161614"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_75_1649)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M51.9375 34.4576V9.51562H39.6328V6H18.3047V9.51562H6V66H50.1797C58.903 66 66 58.903 66 50.1797C66 42.0505 59.8366 35.3348 51.9375 34.4576ZM21.8203 9.51562H36.1172V13.0312H21.8203V9.51562ZM9.51562 62.4844V13.0312H18.3047V16.5469H39.6328V13.0312H48.4219L51.9375 34.4576C46.4577 33.849 42.5358 36.0251 40.2482 37.875C37.3843 39.8051 35.6318 43.6736 35.1345 44.9062C34.4614 46.575 34.3594 49.5855 34.3594 50.1797C34.3594 50.7738 34.5146 54.1306 35.2643 55.4531C36.251 58.2357 37.9952 60.6623 40.2483 62.4844H9.51562ZM50.1797 62.4844C43.3949 62.4844 37.875 56.9645 37.875 50.1797C37.875 43.3949 43.3949 37.875 50.1797 37.875C56.9645 37.875 62.4844 43.3949 62.4844 50.1797C62.4844 56.9645 56.9645 62.4844 50.1797 62.4844Z",
    fill: "#F30002"
  }))), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M48.4216 51.2089L46.1489 48.9363L43.6631 51.4221L48.4216 56.1807L56.6957 47.9064L54.21 45.4207L48.4216 51.2089Z",
    fill: "#F30002"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_75_1649"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 34,
    y: 34,
    width: 32,
    height: 32,
    rx: 16,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCompliant);
export default __webpack_public_path__ + "static/media/compliant.983794387136d96a495bdf9f4bc55e34.svg";
export { ForwardRef as ReactComponent };